export default function localizePath(path, locale = "en") {
  if (locale === "en") {
    return path;
  }

  return `/${locale}${path}`;
}
